import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { resultsCenterRouteI18n } from '../i18n/results-center-route-i18n';

export function resultsCenterRoutePath(): string {
  return `/${langRouteI18n()}/${resultsCenterRouteI18n()}`;
}
